import * as Enumerable from 'linq';
import { DateUtility } from './date.utility';
import { JobTemplateJob } from '../entities/job.templates/job.template.job';
import { JobTemplateWorkOrder } from '../entities/job.templates/job.template.workorder';
import { RecurringJob, RecurringJobStatus, RecurringJobTable, RecurringJobType } from '../entities/job/recurring.job';
import { v4 } from 'uuid';

export class RecurringJobUtility {


    public static getRecurringJobs(jobs: any[]): RecurringJobTable[] {


        const result = Enumerable.from(jobs)
            .select(x => {

                const job = x['recurringJob'] ?? x;

                job['status'] = RecurringJobUtility.getRecurringJobStatus(job);

                return job;
            })
            .where(x => !!x?._id)
            .distinct(x => x?._id)
            .orderBy(x => x?.name)
            .toArray() as any[];


        return result;
    }

    public static getRecurringJobStatus(job: RecurringJob): RecurringJobStatus {

        const today = DateUtility.getDateTime(new Date).startOf('day');

        const endDate = DateUtility.getDateTime(job?.end);

        if (!endDate && job.type === RecurringJobType.Service) {
            return job?.turnOn ? RecurringJobStatus.Active : RecurringJobStatus.Inactive;
        }

        if (endDate < today) {
            return RecurringJobStatus.Expired;
        }

        if (job?.turnOn && endDate >= today)
            return RecurringJobStatus.Active;

        if (!job?.turnOn && endDate >= today)
            return RecurringJobStatus.Inactive;

    }

    public static getAdhocTemplate(): JobTemplateJob {

        return {
            _id: v4(),
            workOrders: [{
                _id: v4(),
                name: 'Default Stage',
                codes: []
            } as JobTemplateWorkOrder]
        } as JobTemplateJob;

    }

}